var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyWorkspaceActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H24C25.1046 1 26 1.89543 26 3V13.8261H1V3Z",
    fill: "#3361CF",
    stroke: "#3361CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16.2174,
    width: 25,
    height: 4.13043,
    fill: "#3361CF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82605,
    y: 20.3478,
    width: 9.56522,
    height: 5.65217,
    fill: "#3361CF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.86951,
    y: 24.0435,
    width: 13.2609,
    height: 1.95652,
    fill: "#3361CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWorkspaceActive);
export default __webpack_public_path__ + "static/media/My Workspace _ active.9b51797c1785c6f52c9c77d370461544.svg";
export { ForwardRef as ReactComponent };